// @ts-ignore
import packageInfo from '../../package.json';
export const environment = {
  production: true,
  apiUrl: 'https://api-vendor.aclarian.com/api/',
  baseUrl: 'https://sacta-vendor.aclarian.com',
  appName: 'Sacramento Transportation Authority | VendorV2',
  tokenizationKey: 'PaQmTu-VE6uUF-9V6acY-jecjXr',
  datadogClientToken: 'pub766aa7510ddf7d70f37ad5d8f4c02ab3',
  datadogApplicationId: 'b1176fe1-f720-445d-be9b-10c4d5b3be49',
  datadogService: 'invoicing_sta_prod',
  ApiKey: '8Cjbr2xWeRrM5U2a',
  env: 'PROD',
  version: packageInfo.version,
};
